import { render } from "./BeneficiaryDetails.vue?vue&type=template&id=7ebe700f&scoped=true"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"

import "./BeneficiaryDetails.vue?vue&type=style&index=0&id=7ebe700f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebe700f"]])

export default __exports__